/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TaskAssigned/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import Tysiav2UserSingleCircle from 'DesignSystem/Svgs/Tysiav2UserSingleCircle/index'



/** @type {import('Simple/types.js').View} */
export default function TaskAssigned({
  children,
  viewPath = "/App/Account/Topbar/Inbox/Content/Content/Messages/All/Content/Message/MessageTypeIcon/TaskAssigned"
  
}) {
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
  return (<React.Fragment
>
<Tysiav2UserSingleCircle
  viewPath={`${viewPath}/Tysiav2UserSingleCircle`}
 width={14}
 height={14}
 fill={dtColorsNeutral500}
/>
{children}
</React.Fragment>)
}